import { sharedSelectors } from 'shared-lib'

export const selectors = { ...sharedSelectors }
